import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "prompt-form-container" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "textarea-container" }
const _hoisted_4 = { class: "form-actions" }
const _hoisted_5 = {
  key: 0,
  type: "submit",
  class: "generate-btn"
}
const _hoisted_6 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_7 = { class: "modal-header" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertPop = _resolveComponent("AlertPop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
      class: "prompt-form"
    }, [
      _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"form-header\" data-v-27eba5d0><h2 class=\"form-title\" data-v-27eba5d0><span class=\"green\" data-v-27eba5d0>Create</span> <span class=\"yellow\" data-v-27eba5d0>Your </span> <span class=\"blue\" data-v-27eba5d0>Drawing</span></h2><p class=\"form-subtitle\" data-v-27eba5d0>Describe what you&#39;d like to color and we&#39;ll generate it for you</p></div>", 1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("label", {
          for: "prompt",
          class: "form-label"
        }, [
          _createElementVNode("span", { class: "label-text" }, "Make me a coloring of:"),
          _createElementVNode("span", { class: "label-decoration" }, "✨")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("textarea", {
            id: "prompt",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.prompt) = $event)),
            placeholder: "A T-rex having a birthday party with his dinosaurs friends",
            rows: "4",
            class: "form-textarea",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.form.prompt]
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "textarea-border" }, null, -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.loading && !_ctx.alertStore.alert)
          ? (_openBlock(), _createElementBlock("button", _hoisted_5, _cache[9] || (_cache[9] = [
              _createElementVNode("span", { class: "btn-icon" }, "🎨", -1),
              _createElementVNode("span", { class: "btn-text" }, "Generate", -1),
              _createElementVNode("span", { class: "btn-icon" }, "🎨", -1),
              _createElementVNode("div", { class: "btn-shine" }, null, -1)
            ])))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[10] || (_cache[10] = [
              _createElementVNode("div", { class: "loading-spinner" }, null, -1),
              _createElementVNode("p", { class: "loading-text" }, "Creating your masterpiece...", -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_AlertPop)
    ], 32),
    (_ctx.isModalOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "modal-title" }, "Your Coloring Page is Ready!", -1)),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "modal-close"
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.modalImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.modalImage,
                    alt: "Generated coloring page",
                    class: "modal-image"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.printImage && _ctx.printImage(...args))),
                class: "modal-btn print-btn"
              }, _cache[13] || (_cache[13] = [
                _createElementVNode("span", { class: "btn-icon" }, "🖨️", -1),
                _createTextVNode(" Print ")
              ])),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "modal-btn close-btn"
              }, _cache[14] || (_cache[14] = [
                _createElementVNode("span", { class: "btn-icon" }, "✨", -1),
                _createTextVNode(" Done ")
              ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}